import { useQueryClient } from 'react-query';
import { useCallback, useState } from 'react';
import { queryKeysShutdowns } from '../../../../shared/constants/queryKeys';
import { selectShutdownsFilter } from '../../model/selectors';
import { useSelector } from 'react-redux';
import useSaveFilter from '../../../../shared/api/mutation/useSaveFilter';

const useShutdownFilterSaver = () => {
  const queryClient = useQueryClient();

  const { onSaveFilter, isSaveFilterLoading } = useSaveFilter();

  const [savePopoverVisible, setSavePopoverVisible] = useState(false);

  const handleSaveFilterVisibleChange = useCallback((visible) => {
    setSavePopoverVisible(visible);
  }, []);

  const closePopover = useCallback(() => {
    setSavePopoverVisible(false);
  }, []);

  const existingFilters =
    queryClient.getQueryData(queryKeysShutdowns.savedFilters()) || [];

  const {
    visible,
    filterChanged,
    chosenFilterId,
    chosenFilterName,
    ...filterToSave
  } = useSelector(selectShutdownsFilter);

  const saveFilter = async ({ filterName }) => {
    if (!filterName || filterName.length === 0 || /^\s*$/.test(filterName))
      return;

    const replace = existingFilters.find((e) => e.name === filterName);

    await onSaveFilter({
      Filter: JSON.stringify(filterToSave),
      name: filterName,
      id: replace ? replace.id : null,
      Type: 'ALERT',
    });

    setSavePopoverVisible(false);
  };

  return {
    onSaveFilter: saveFilter,
    savePopoverVisible,
    handleSaveFilterVisibleChange,
    closePopover,
    isSaveFilterLoading,
  };
};

export default useShutdownFilterSaver;
